/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type ConfigGroupsSelect_CustomerFragment = { __typename: 'Customer', id: string, groups: Array<{ __typename: 'Group', id: string, name: string }> };

export type ConfigGroupsSelect_ConfigFragment = { __typename: 'ConfigurationModel', id: string };

export type ConfigGroupsSelect_GroupFragment = { __typename: 'Group', id: string, name: string };

export const ConfigGroupsSelect_CustomerFragmentDoc = gql`
    fragment ConfigGroupsSelect_customer on Customer {
  id
  groups {
    id
    name
  }
}
    `;
export const ConfigGroupsSelect_ConfigFragmentDoc = gql`
    fragment ConfigGroupsSelect_config on ConfigurationModel {
  id
}
    `;
export const ConfigGroupsSelect_GroupFragmentDoc = gql`
    fragment ConfigGroupsSelect_group on Group {
  id
  name
}
    `;